import { useTranslation } from "@/app/i18n/client";

export default function ExpiredPage() {
    const { t } = useTranslation();
    const bgImage = "/assets/images/under-construction-bg.webp";

    return (
        <div
            className="flex items-center justify-center h-screen px-3"
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}>
            <div className="bg-white backdrop-blur-lg rounded-xl shadow-lg p-8 max-w-md text-center">
                {/* Title */}
                <h1 className="mt-6 lg:text-4xl text-2xl font-bold ">{t("maintenance.title")}</h1>

                {/* Description */}
                <p className="mt-4 text-lg">{t("maintenance.desc")}</p>
            </div>
        </div>
    );
}
